export enum LoadingState {
  Loading = "loading",
  GraphqlError = "graphqlError",
  Success = "success",
  NetworkError = "networkError",
}
